<template>
  <div class="toolbar">
    <div @click="shutLable" class="images el-icon-full-screen">
      <p style="font-size: 15px;padding-top:6px">全屏</p>
    </div>
    <div @click="returnModel" class="images el-icon-aim">
      <p style="font-size: 15px;padding-top:6px">回正</p>
    </div>
    <div @click="changeBackground" class="images el-icon-picture-outline">
      <p style="font-size: 15px;padding-top:6px">背景</p>
    </div>
    <div @click="ModelReset" class="images el-icon-refresh">
      <p style="font-size: 15px;padding-top:6px">还原</p>
    </div>
    <div @click="ModelRotation" class="images el-icon-refresh-left">
      <p style="font-size: 15px;padding-top:6px">旋转</p>
    </div>
    <div class="images el-icon-view" @click="ModelDisplayAndHiding" v-if="EyeDisplay">
      <p style="font-size: 15px;padding-top:6px">全隐</p>
    </div>
    <div class="images" @click="ModelDisplayAndHiding" v-else>
      <img src="/static/images/eye-blocked.png" style="height: 20px;width: 20px;" alt="">
      <p style="font-size: 15px;padding-top:6px">全显</p>
    </div>
    <transition enter-active-class="animate__animated animate__fadeInRight"
      leave-active-class="animate__animated animate__fadeOutRight">
      <div class="changebackColor" v-show="backgroundColorHide">
        <ul style="border: 1px solid gray;background-color: rgba(20,33,53,0.65);border-radius: 8px;">
          <li v-for="(item, index) in backgroundColor" :key="index"
            style="border-radius: 8px;width: 35px;height: 35px;cursor:pointer;margin: 8px 5px;"
            @click="changeBackgroundColor(item)">
            <div
              :style="{ borderRadius: '8px', background: index == 0 ? 'gray' : item, width: '100%', height: '100%' }">
            </div>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>
<script>
import Bus from "../../utils/bus";
import { mapMutations } from "vuex";
import { mapState } from "vuex";

export default {
  data() {
    return {
      shutLableBools: true,
      MenuBarDisplayBool: true,
      MenuBarDisplayColor: true,
      ModelRotation1: false,
      EyeDisplay: true,
      meshs: null,
      ListColors: null,
      MeasurementBool: false,
      backgroundColorHide: false,
      backgroundColor: [
        "radial-gradient(rgb(255, 255, 255) 113px, rgb(52, 63, 76) 130%)",
        "radial-gradient(at center center,rgb(245, 245, 245) 25%,rgb(0, 0, 0) 164%)",
        "linear-gradient(#7d8fa3, #1b1c1e)",
        "white",
        "#000000"
      ],
      initialScale: null,
    };
  },
  computed: {
    ...mapState(["eyeDisplay", "modelVisible"]),
  },

  methods: {
    ...mapMutations([
      "setModelVisible", "setMeasurementVisible", "setEyeDisplay", "setMenuVisible", "setLabelEyes", "setBackgroundColor", "setModelReset"]),
    shutLable() {
      this.shutLableBools = !this.shutLableBools
      this.setMenuVisible(this.shutLableBools)
    },
    // 模型回正
    returnModel() { this.setModelReset(true) },
    // 修改颜色
    changeBackgroundColor(item) {
      const div = document.getElementById("lLJDLFDASJ")
      item == "white" ? div.style.color = "black" : div.style.color = "white"
      this.setBackgroundColor(item)
    },
    // 背景切换
    changeBackground() {
      this.backgroundColorHide = !this.backgroundColorHide
    },
    // 模型还原
    ModelReset() {
      this.setModelReset(true)
      this.EyeDisplay = true
      this.setEyeDisplay(this.EyeDisplay)
      this.setLabelEyes(1)

      const configList = JSON.parse(localStorage.getItem('listColor') || '[]')

      this.meshs.forEach(mesh => {
        const config = configList.find(c => c.modelId === mesh.model_id)
        if (!config) return

        if (config.modelColor) {
          const [r, g, b] = config.modelColor.split(',').map(v => Number(v) / 255)
          mesh.material.color.setRGB(r || 0, g || 0, b || 0)
        }

        const opacity = Number(config.modelOpacity)
        mesh.visible = true
        mesh.material.opacity = opacity
        mesh.material.transparent = opacity < 1
        mesh.material.depthWrite = opacity >= 1
        if (opacity >= 1) mesh.material.needsUpdate = true

        const el = document.getElementById(mesh.model_id)
        if (el) {
          const statusEl = el.childNodes[4]
          if (statusEl) statusEl.innerText = `状态:${opacity * 100}%`
          const colorEl = el.childNodes[2]
          if (colorEl) colorEl.style.background = `rgb(${config.modelColor})`
          el.style.border = `2px solid rgb(${config.modelColor})`
        }
      })

      const storeList = this.$store.state.listColor
      if (storeList) {
        storeList.forEach(item => {
          const orig = configList.find(c => c.modelId === item.modelId)
          if (orig) {
            item.modelOpacity = Number(orig.modelOpacity)
            item.icons = Number(orig.modelOpacity) !== 0
          }
        })
      }
    },
    ModelRotation(e) {
      this.ModelRotation1 = !this.ModelRotation1;
      Bus.$emit("val", this.ModelRotation1);
    },
    // 模型显示与隐藏
    ModelDisplayAndHiding(e) {
      this.EyeDisplay = !this.EyeDisplay;
      this.EyeDisplay ? this.setLabelEyes(2) : this.setLabelEyes(3)
      this.meshs.forEach((item, index) => {
        if (this.EyeDisplay) {
          if (item.material.opacity == 1) {
            document.getElementById(
              item.model_id).childNodes[4].innerText = `状态:${1 * 100}%`
            item.visible = true;
            item.material.depthWrite = true;
            item.material.transparent = false;
            item.material.needsUpdate = true;

          } else if (item.material.opacity < 1 && item.material.opacity > 0) {
            item.material.transparent = true
            item.material.depthWrite = false;
            document.getElementById(item.model_id).childNodes[4].innerText = `状态:${item.material.opacity * 100}%`
            item.visible = true;
          }
        }
        else {
          item.visible = false;
          item.material.depthWrite = false;
          item.material.transparent = false;
          document.getElementById(
            item.model_id
          ).childNodes[4].innerText = `状态:${0 * 100}%`
        }
      });
    },
  },
  mounted() {
    this.meshs = this.$store.state.meshList;
    this.ListColors = this.$store.state.listColor
    Bus.$on("vals", (data) => {
      this.ModelRotation1 = data;
    });

  }
};
</script>

<style scoped lang="scss">
.icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  stroke-width: 0;
  stroke: currentColor;
  fill: currentColor;
}

.toolbar {
  position: relative;

  >.images {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    width: 45px;
    border: 2px solid skyblue;
    border-radius: 8px;
    height: 55px;
    margin: auto 2px;
    font-size: 20px;
    justify-content: center;
    /* 水平居中 */
    align-items: center;
    /* 垂直居中 */
    color: white;
  }

  .changebackColor {
    position: absolute;
    top: calc(75px + 0.15rem);
    right: 15px;
  }

}

.toolbar {
  width: 100vw;
  height: 60px;
  background: radial-gradient(rgb(255, 255, 255) 0, rgb(52, 63, 76) 0%);
  opacity: .9;
  display: flex;
  justify-content: flex-end;
}
</style>